import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { isPlatformBrowser } from '@angular/common';
import { Platform } from '@angular/cdk/platform';

@Injectable({
    providedIn: 'root'
})
export class OnlineStatusHandler {
    public onlineEvent: Observable<Event>;
    public offlineEvent: Observable<Event>;
    private platform: Platform;

    constructor(@Inject(PLATFORM_ID) platform) {
        this.platform = platform;
        /**
         * Get the online/offline status from browser window
         */
        if (isPlatformBrowser(platform)) {
            this.onlineEvent = fromEvent(window, 'online');
            this.offlineEvent = fromEvent(window, 'offline');
        }
    }

    public get isOnline() {
        return isPlatformBrowser(this.platform) ? navigator.onLine : true;
    }
}
